/* template */
<template minapp="mpx" xlang="wxml"><div class="card-frame-container"><div :style="[(cardTitleStyle)] | transRpxStyle" class="card-frame-title"><div :style="[(titleStyle)] | transRpxStyle" class="title-area"><mpx-image :src="(titleInfo.newCustomerIcon)" class="title-customer-icon" v-if="(titleInfo.newCustomerIcon)"/><mpx-image :src="(titleInfo.icon)" class="title-icon" v-if="(titleInfo.icon)"/><span class="customer-text" v-if="(titleInfo.newCustomerText)">{{titleInfo.newCustomerText}}</span><special-text :rules="(specialRules)" :text="(titleInfo.text)" class="title-text" v-if="(titleInfo.text)"/></div><mpx-view :style="[(extraStyle)] | transRpxStyle" @tap="clickExtra" class="extra-area" v-if="(extraInfo.text)"><span class="extra-text">{{ extraInfo.text }}</span></mpx-view></div><div class="card-frame-content"><slot></slot></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf4806b60"}'>
  .card-frame-container
    padding 12px
    .card-frame-title
      display flex
      align-items center
      justify-content space-between
      .title-area
        display flex
        align-items center
        .title-customer-icon
          background-size 100% 100%
          width 86px
          height 28px
          margin-right 4px
        .customer-text
          color #968378
          font-size 10px
        .title-text
          font-size 16px
          font-family PingFang SC
          line-height 16px
          font-weight 600
        .title-icon
          width 16px
          height 16px
          flex-shrink 0
          margin-right 4px
      .extra-area
        position relative
        line-height 12px
        .extra-text
          font-family PingFang SC
          font-size 12px
          font-weight normal
          padding-right 6px
          &::after
            content ''
            width 4px
            height 4px
            border-top 1px solid
            border-right 1px solid
            position absolute
            top 5px
            right 0
            transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf4806b60"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf4806b60%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf4806b60%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf4806b60"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf4806b60/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'special-text':getComponent(require("../../../node_modules/@didi/mpx-ui/src/components/special-text/index.mpx?isComponent&outputPath=components%2Findex4b847508%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
